import { all } from "redux-saga/effects";
import LoginAndRegisterWatcherSaga from "../LoginAndRegister/LoginAndRegisterWatcherSaga";
import CategoriesWatcherSaga from "../Categories/CategoriesWatcherSaga";
import HomeWatcherSaga from "../Home/HomeWatcher";
import CurriculumWatcherSaga from "../Curriculam/CurriculumWatcher";
import TestimonialWatcherSaga from "../Testimonial/TestimonialWatcher";
import ChurchWatcherSaga from "../Church/ChurchSaga";
import AvailableUsersWatcherSaga from "../Users/saga";
import BibleWatcherSaga from "../Bible/BibleWatcher";
import PlansWatcherSaga from "../Plan/saga";
import GroupsWatcherSaga from "../Group/saga";
import PrayerWatcherSaga from "../Prayer/PrayerSaga";
import CommentWatcherSaga from "../comments/CommentWatcherSaga";
export function* allAppRootSagas() {
  yield all([
    LoginAndRegisterWatcherSaga(),
    CategoriesWatcherSaga(),
    HomeWatcherSaga(),
    CurriculumWatcherSaga(),
    TestimonialWatcherSaga(),
    ChurchWatcherSaga(),
    AvailableUsersWatcherSaga(),
    BibleWatcherSaga(),
    PlansWatcherSaga(),
    GroupsWatcherSaga(),
    PrayerWatcherSaga(),
    CommentWatcherSaga()
  ]);
}
